<template>
  <div class="tenderlogin">
    <div class="login-item">
      <div class="tool">
        <img src="../../assets/img/loginpic.png" alt="" />
      </div>
      <div class="box">
        <div class="loginTitle">新吴区建设综合信息平台</div>
        <div class="loginTitle2">监管机构管理系统</div>
        <div class="main">
          <p class="h2">用户登录</p>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item prop="username" style="margin-bottom: 0.3125rem">
              <el-input
                placeholder="请输入用户名"
                @keyup.enter.native="submitForm('ruleForm')"
                v-model.trim="ruleForm.username"
                type="text"
              >
                <img slot="prefix" src="../../assets/img/user_icon.png"
              /></el-input>
            </el-form-item>
            <el-form-item prop="password" style="margin-bottom: 0.3125rem">
              <el-input
                placeholder="请输入密码"
                v-model.trim="ruleForm.password"
                type="password"
                @keyup.enter.native="submitForm('ruleForm')"
              >
                <img slot="prefix" src="../../assets/img/password_icon.png" />
              </el-input>
            </el-form-item>
            <div style="text-align: left; margin-bottom: 0.3125rem">
              <el-checkbox v-model="checked1">记住账号</el-checkbox>
              <el-checkbox v-model="checked2">记住密码</el-checkbox>
            </div>
            <div>
              <el-button @click="submitForm('ruleForm')">登录</el-button>
            </div>
          </el-form>
        </div>
        <div class="text">
          本系统推荐使用Chrome、搜狗、Edge、360[非兼容模式]等浏览器
        </div>
        <div class="bottomtip">
          <div class="imgitem">
            <img src="./dzjg.png" alt="" @click="dzgotip" />
          </div>
          <div>
            <div>
              <span>无锡市新吴区住房和城乡建设局主办</span>
              <span>{{ `\u3000电子邮箱：xwqazjz@163.com` }}</span>
            </div>
            <div>
              <span class="chooseone" @click="ipgotip"
                >苏ICP备10218726号-2</span
              >
              <span class="chooseone" @click="sagotip">{{
                `\u3000苏公网安备32021402000001号`
              }}</span>
              <span>{{ `\u3000网站标识码：` }}</span>
              <span>3202900001</span>
            </div>
          </div>
          <div class="imgitemone">
            <img src="./zfwz.png" alt="" @click="zfgotip" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: process.env.VUE_APP_URL_BG,
      visible1: false,
      visible: false,
      checked1: false,
      checked2: false,
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.open();
    if (sessionStorage.getItem("username")) {
      this.ruleForm.username = sessionStorage.getItem("username");
      this.checked1 = true;
    }
    if (sessionStorage.getItem("password")) {
      this.ruleForm.password = sessionStorage.getItem("password");
      this.checked2 = true;
    }
    if (sessionStorage.getItem("urlItem")) {
      this.$store.commit(
        "tabsActiveFn",
        JSON.parse(sessionStorage.getItem("urlItem"))
      );
    }
    console.log(this.$store.state);
  },
  methods: {
    open() {
      if (
        location.host == "58.215.171.204:9090" &&
        new Date().getTime() < new Date("2022/09/26").getTime()
      ) {
        this.$confirm(
          "无锡市新吴区建设综合信息平台计划于2022年9月24日中午12点开始进行迁移，预计至9月25日晚24点迁移完成。迁移期间系统无法访问，迁移后将启用新地址，届时将弹出提示，请注意调整收藏夹内地址，带来不便敬请见谅。",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false, //是否可以点击空白处关闭弹窗
          }
        );
      } else if (
        location.host == "58.215.171.204:9090" &&
        new Date().getTime() >= new Date("2022/09/26").getTime()
      ) {
        this.$confirm(
          '无锡市新吴区建设综合信息平台已迁移至新地址，新的登录地址为<a href="http://58.215.195.190:9090/wndjsxwjg">http://58.215.195.190:9090/wndjsxwjg</a>；原地址已失效，请注意调整收藏夹内地址，带来不便敬请见谅。',
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false, //是否可以点击空白处关闭弹窗
            dangerouslyUseHTMLString: true,
          }
        ).then(() => {
          window.location.href = "http://58.215.195.190:9090/wndjsxwjg";
        });
      }
    },
    // 登录
    submitForm(formName) {
      this.getlogin();
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     this.getlogin();
      //   } else {
      //     return false;
      //   }
      // });
    },
    getlogin() {
      this.$http
        .axiosPost("/userController/jsLogin", {
          username: this.ruleForm.username,
          password: this.ruleForm.password,
          gongchengId: "",
        })
        .then((res) => {
          console.log(res);
          if (res.state) {
            this.rememberUser(this.checked1);
            this.rememberPassword(this.checked2);
            console.log(this.$store.state);
            this.$cookieStore.setCookie(
              "token",
              res.token,
              24 * 60 * 60 * 1000
            );
            this.$cookieStore.setCookie("name", res.name, 24 * 60 * 60 * 1000);
            // if (this.$store.state.urlItem.path) {
            //   this.$router.push({
            //     path: this.$store.state.urlItem.path,
            //   });
            // } else {
            //   this.$router.push({
            //     path: '/main/xwls',
            //   });
            // }
            this.$router.push({
              path: "/main/xwls",
            });
            sessionStorage.setItem("token", res.token);
            sessionStorage.setItem("quyu", res.quyu);
            sessionStorage.setItem("name", res.name);
            if (this.checked1 === true) {
              sessionStorage.setItem("username", this.ruleForm.username);
            }
            if (this.checked2 === true) {
              sessionStorage.setItem("password", this.ruleForm.password);
            }
          } else {
            this.$notify.closeAll();
            this.$notify.error({
              title: "错误",
              message: res.message,
              duration: 1000,
            });
          }
        });
    },
    // 记住用户名
    rememberUser(e) {
      if (e) {
        this.$cookieStore.setCookie(
          "username",
          this.ruleForm.username,
          720 * 60 * 60 * 1000
        );
      } else {
        this.$cookieStore.delCookie("username");
      }
    },
    // 记住密码
    rememberPassword(e) {
      if (e) {
        this.$cookieStore.setCookie(
          "password",
          this.ruleForm.password,
          720 * 60 * 60 * 1000
        );
      } else {
        this.$cookieStore.delCookie("password");
      }
    },
    ipgotip() {
      window.open("https://beian.miit.gov.cn/");
    },
    sagotip() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021402000001"
      );
    },
    dzgotip() {
      window.open(
        "https://bszs.conac.cn/sitename?method=show&id=541599663E132F88E053022819ACD3B9"
      );
    },
    zfgotip() {
      window.open(
        "https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=3202900001&url=https%3A%2F%2Fwww.wnd.gov.cn/%2F"
      );
    },
  },
};
</script>
<style scoped lang="less">
.tenderlogin {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.login-item {
  display: flex;
  width: 100%;
}

.tool {
  width: 55%;
  text-align: right;

  img {
    width: 9.7125rem /* 777/80 */;
  }
}

.box {
  width: 7.875rem /* 630/80 */;
  margin-left: -1.625rem /* 130/80 */;
}

.h2 {
  margin-bottom: 0.5rem /* 40/80 */;
  font-size: 0.375rem /* 30/80 */;
  color: #20a3f5;
  letter-spacing: 3px;
}

.loginTitle {
  font-size: 0.5rem;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 0.25rem /* 20/80 */;
}
.loginTitle2 {
  font-size: 0.375rem /* 30/80 */;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 0.25rem /* 20/80 */;
  text-align: right;
}

.el-button {
  width: 100%;
  background: #20a3f5;
  border-color: #20a3f5;
  color: #fff;
  border-radius: 0;
  font-size: 0.3125rem /* 25/80 */;
  font-weight: normal;
  letter-spacing: 3px;
  height: 0.6975rem /* 55.8/80 */;
}
/deep/ .el-button:hover {
  color: #fff;
  border-color: #20a3f5;
  background-color: #20a3f5;
}
.main {
  padding: 0.625rem /* 50/80 */ 0.6875rem /* 55/80 */;
  background: rgba(3, 18, 48, 0.28);
  margin-top: 0.5625rem /* 45/80 */;

  img {
    width: 0.2875rem /* 23/80 */;
    margin-top: 0.2rem /* 16/80 */;
    margin-left: 10px;
  }
}

.text {
  color: rgba(252, 226, 83, 1);
  margin-top: 0.375rem /* 30/80 */;
}
.bottomtip {
  color: #aaaaaa;
  font-size: 12px;
  line-height: 23px;
  position: fixed;
  bottom: 0%;
  left: 32%;
  display: flex;
  .imgitem {
    margin-right: 20px;
    img {
      width: 40px;
      height: 45px;
      cursor: pointer;
    }
  }
  .imgitemone {
    margin-left: 20px;
    img {
      width: 80px;
      height: 40px;
      cursor: pointer;
    }
  }
  .chooseone {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue